import { render, staticRenderFns } from "./CloseOrderModal.vue?vue&type=template&id=48dbca87&"
import script from "./CloseOrderModal.vue?vue&type=script&lang=js&"
export * from "./CloseOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports